<script setup lang="ts">
import { useFlowEditorContext } from '../../composables/useFlowEditor'
import type { FlowNode } from '../../model/types'

/** Macro start/end/call settings. Port count changes propagate to macro calls. */
defineProps<{ selectedNode: FlowNode }>()

const editor = useFlowEditorContext()
const { debounced: di, flush: db } = editor.inspector
const { updateMacroName, updateMacroInputCount, updateMacroOutputCount, updateMacroRef } =
  editor.inspector
const { macroOptions } = editor
</script>

<template>
  <!-- Macro Start -->
  <template v-if="selectedNode.type === 'macro-start'">
    <label>
      <span>{{ $t('flow.macroName') }}</span>
      <input
        :value="selectedNode.data.macroName || ''"
        type="text"
        placeholder="e.g. handle-card"
        @input="di(updateMacroName)($event)"
        @blur="db(updateMacroName)($event)"
      />
    </label>
    <label>
      <span>{{ $t('flow.inputsOutputsSymmetric') }}</span>
      <input
        :value="selectedNode.data.inputCount ?? 1"
        type="number"
        min="1"
        max="8"
        @input="di(updateMacroInputCount)($event)"
        @blur="db(updateMacroInputCount)($event)"
      />
    </label>
  </template>

  <!-- Macro End -->
  <template v-if="selectedNode.type === 'macro-end'">
    <label>
      <span>{{ $t('flow.outputsInputsSymmetric') }}</span>
      <input
        :value="selectedNode.data.outputCount ?? 1"
        type="number"
        min="1"
        max="8"
        @input="di(updateMacroOutputCount)($event)"
        @blur="db(updateMacroOutputCount)($event)"
      />
    </label>
  </template>

  <!-- Macro Call -->
  <template v-if="selectedNode.type === 'macro-call'">
    <label>
      <span>{{ $t('flow.macroToCall') }}</span>
      <select
        :value="selectedNode.data.macroRef || ''"
        @change="updateMacroRef(($event.target as HTMLSelectElement).value)"
      >
        <option value="">{{ $t('flow.selectMacro') }}</option>
        <option v-for="m in macroOptions" :key="m.name" :value="m.name">
          {{ m.name }}
        </option>
      </select>
    </label>
    <div v-if="selectedNode.data.macroRef" class="flow-settings__meta">
      {{ selectedNode.data.inputCount ?? 1 }} {{ $t('flow.inputs') }} ·
      {{ selectedNode.data.outputCount ?? 1 }} {{ $t('flow.outputs') }}
    </div>
  </template>
</template>

<style scoped src="../styles/inspectorForm.css"></style>
